const base64js = require('base64-js');
import Validator from 'validatorjs';
import { request } from "https";
import utilityService from "../../services/common/utility-service";
//@ts-check

/* @ngInject */
export default class PaymentCtrl {
    constructor(
        $sce,
        $state,
        $scope,
        Utility,
        $timeout,
        $interval,
        $uibModal,
        $rootScope,
        PagingService,
        BuildingsService,
        NotificationService,
        LocalStorageService,
        AuthorizationService,
        AuthenticationService,
        paymentApprovalsDataService,
    ) {
        this.$sce = $sce;
        this.$scope = $scope;
        this.$state = $state;
        this.Utility = Utility;
        this.$timeout = $timeout;
        this.$interval = $interval;
        this.$uibModal = $uibModal;
        this.$rootScope = $rootScope;
        this.PagingService = PagingService;
        this.BuildingsService = BuildingsService;
        this.NotificationService = NotificationService;
        this.LocalStorageService = LocalStorageService;
        this.AuthorizationService = AuthorizationService;
        this.AuthenticationService = AuthenticationService;
        this.paymentApprovalsDataService = paymentApprovalsDataService;
        this.hasPaymentsInitiallySucceeded = false;
        this.hasInitialisedFromSession = false;

        this.$rootScope.$on('user-session-set', () => {
            if (!this.hasInitialisedFromSession) {
                this.activate();
                this.hasInitialisedFromSession = true;
            }
        });

        this.init();
        this.activate();
        this.registerEventHandlers();

        this.defaultAddEditPayment = {
            PaymentType: undefined,
            InvoiceNumber: undefined,
            ServiceProviderId: undefined,
            TotalInvoiceAmount: undefined,
            FuturePaymentDate: undefined,
            Allocations: [],
            Invoice: undefined,
            SupportingDocuments: [],
            IsTaxable: false,
            VatRatePercentage: undefined
        }

        this.Allocations = {
            GLAccount: undefined,
            Amount: undefined
        }

        this.defaultAddEditPaymenOptions = {
            showDuplicateInvoiceWarning: false,
            showDuplicateInvoiceError: false,
            isCheckingForDuplicateInvoice: false,
            tempServiceProvider: undefined,
            futureDatechecked: false,
            serviceProviderChecked: false,
            searchServiceTerm: '',
            schemeConfirmed: false,
            serviceProviderConfirmed: false,
            invoiceNumberConfirmed: false,
            amountConfirmed: false,
            invoiceCaptureConfirmed: false
        }

        this.addEditPayment = {};
        this.addEditPaymenOptions = {};

        //TODO: Use this ssame logic to reset the payment object when requirued
        this.resetPaymentData();

        this.captureFormErrors();
    }

    resetPaymentData() {
        this.$timeout(() => {
            Object.assign(this.addEditPayment, this.defaultAddEditPayment);
            Object.assign(this.addEditPaymenOptions, this.defaultAddEditPaymenOptions);
            this.allocationRows = [];
            this.selectedserviceProviderName = undefined;
            this.addEditPayment.SupportingDocuments = [];
        });
    }

    init() {
        this.query = '';
        this.isBusy = false;
        this.searchTerm = '';
        this.awaitQueries = false;
        this.selectedItemIndex = 0;
        this.panelCollapsed = null;
        this.currentSchemeRef = '';
        this.scrollableStyling = ``;
        this.showBulkApprove = true;
        this.paymentsPromise = null;
        this.isAmountChecked = false;
        this.isBusySearching = false;
        this.isBusySaving = false;
        this.selectedPagingLimit = 5;
        this.isBulkApproving = false;
        this.webPaymentApproval = [];
        this.portfolioArrayLength = 0;
        this.isInvoiceChecked = false;
        this.isSupplierChecked = false;
        this.paymentApprovalsCount = 0;
        this.selectedLineItemIndex = 0;
        this.limits = [5, 10, 15, 20];
        this.searchButtonActive = false;
        this.paymentsForBulkApproval = [];
        this.invoiceApprovedOverlay = false;
        this.webPaymentApprovalApproved = [];
        this.paymentsDataService = undefined;
        this.webPaymentApprovalIndividual = {
            Notes: null,
            Attachments: []
        };
        this.isPagingNavigationVisible = false;
        this.approvedPaymentsPaging = this.PagingService;
        this.selectedserviceProviderName = undefined;
        this.canPaymentcapture = false;
        this.allocationRows = [];
        this.attachment = [];
        this.allocationAmountMatchedInvoiceTotal = false;
    }

    registerEventHandlers() {
        this.$scope.$on('payments-bulk-is-busy', () => {
            this.paymentsDataService.approvalsData.approvals.forEach((payment) => {
                this.paymentsForBulkApproval.forEach((innerPayment) => {
                    if (innerPayment.PaymentId === payment.PaymentId) {
                        payment.isApproving = true;
                        return false;
                    }
                });
            });
        });

        this.$scope.$on('payments-bulk-is-done', () => {
            this.paymentsDataService.approvalsData.approvals.forEach((payment) => {
                this.paymentsForBulkApproval.forEach((innerPayment) => {
                    if (innerPayment.PaymentId === payment.PaymentId) {
                        payment.isApproving = false;
                        return false;
                    }
                });
            });

            this.paymentsForBulkApproval = [];
        });

        this.$scope.$on('payment-is-busy', (evt, paymentId, type) => {
            let paymentIndex = -1;
            this.paymentsDataService.approvalsData.approvals.forEach((payment, index) => {
                if (payment.PaymentId == paymentId) {
                    paymentIndex = index;
                    return false;
                }
            });

            if (paymentIndex > -1) {
                if (type.toLowerCase().indexOf('query') !== -1) {
                    this.paymentsDataService.approvalsData.approvals[paymentIndex].isQuerying = true;
                    this.paymentsDataService.approvalsData.approvals[paymentIndex].isApproving = false;
                    this.paymentsDataService.approvalsData.approvals[paymentIndex].isUnApproving = false;
                    if (this.webPaymentApprovalIndividual) {
                        this.webPaymentApprovalIndividual.isQuerying = true;
                        this.webPaymentApprovalIndividual.isApproving = false;
                        this.webPaymentApprovalIndividual.isUnApproving = false;
                    }
                } else if (type.toLowerCase().indexOf('unapproval') !== -1) {
                    this.paymentsDataService.approvalsData.approvals[paymentIndex].isQuerying = false;
                    this.paymentsDataService.approvalsData.approvals[paymentIndex].isApproving = false;
                    this.paymentsDataService.approvalsData.approvals[paymentIndex].isUnApproving = true;
                    if (this.webPaymentApprovalIndividual) {
                        this.webPaymentApprovalIndividual.isQuerying = false;
                        this.webPaymentApprovalIndividual.isApproving = false;
                        this.webPaymentApprovalIndividual.isUnApproving = true;
                    }
                } else {
                    this.paymentsDataService.approvalsData.approvals[paymentIndex].isApproving = true;
                    this.paymentsDataService.approvalsData.approvals[paymentIndex].isQuerying = false;
                    this.paymentsDataService.approvalsData.approvals[paymentIndex].isUnApproving = false;
                    if (this.webPaymentApprovalIndividual) {
                        this.webPaymentApprovalIndividual.isApproving = true;
                        this.webPaymentApprovalIndividual.isQuerying = false;
                        this.webPaymentApprovalIndividual.isUnApproving = false;
                    }
                }
            }
        });

        this.$scope.$on('payment-is-done', (evt, paymentId, type) => {
            let paymentIndex;
            this.paymentsDataService.approvalsData.approvals.forEach((payment, index) => {
                if (payment.PaymentId == paymentId) {
                    paymentIndex = index;
                    return false;
                }
            });

            if (paymentIndex) {
                this.paymentsDataService.approvalsData.approvals[paymentIndex].isQuerying = false;
                this.paymentsDataService.approvalsData.approvals[paymentIndex].isApproving = false;
                this.paymentsDataService.approvalsData.approvals[paymentIndex].isUnApproving = false;
                if (this.webPaymentApprovalIndividual) {
                    this.webPaymentApprovalIndividual.isQuerying = false;
                    this.webPaymentApprovalIndividual.isApproving = false;
                    this.webPaymentApprovalIndividual.isUnApproving = false;
                }
            }
        });

        this.$scope.$on('selected-building-changed', (event, newValue) => {
            this.onSelectedBuildingChanged(this, newValue);
        });

        this.$scope.$on('approvals-count-changed', (event, currentCount) => {
            this.paymentApprovalsCount = currentCount;
        });

        this.$scope.$watch(
            'paymentApprovalVm.approvedPaymentsPaging.pageNumber',
            (newVal, oldVal) => {
                if (oldVal && newVal !== oldVal) {
                    this.searchPayments();
                }
            },
            true
        );

        this.$scope.$watch(
            'paymentApprovalVm.approvedPaymentsPaging.maxPage',
            () => {
                this.approvedPaymentsPaging.pageNumber = 1;
            },
            true
        );

        this.$scope.$watch(
            'paymentApprovalVm.searchTerm',
            () => {
                if (this.isInvoiceChecked) {
                    if (this.searchTerm && this.searchTerm.hasOwnProperty('length') && this.searchTerm.length >= 1) {
                        this.searchButtonActive = true;
                        return;
                    }
                }

                if (this.isSupplierChecked) {
                    if (this.searchTerm && this.searchTerm.hasOwnProperty('length') && this.searchTerm.length >= 3) {
                        this.searchButtonActive = true;
                        return;
                    }
                }

                if (this.isAmountChecked) {
                    if (this.searchTerm && this.searchTerm.hasOwnProperty('length') && this.searchTerm.length >= 1) {
                        const isDecimal = this._isDecimal(this.searchTerm);
                        if (isDecimal) {
                            this.searchButtonActive = true;
                            return;
                        }
                    }
                }

                if (
                    !this.isInvoiceChecked &&
                    !this.isSupplierChecked &&
                    !this.isAmountChecked &&
                    (!this.searchTerm || this.searchTerm === '')
                ) {
                    this.searchButtonActive = true;
                    return;
                }

                this.searchButtonActive = false;
            },
            true
        );

        this.$scope.$watch(
            'paymentApprovalVm.isInvoiceChecked',
            () => {
                if (this.isInvoiceChecked) {
                    this.isSupplierChecked = false;
                    this.isAmountChecked = false;
                    if (this.searchTerm && this.searchTerm.hasOwnProperty('length') && this.searchTerm.length >= 1) {
                        this.searchButtonActive = true;
                        return;
                    }
                }

                if (
                    !this.isInvoiceChecked &&
                    !this.isSupplierChecked &&
                    !this.isAmountChecked &&
                    (!this.searchTerm || this.searchTerm === '')
                ) {
                    this.searchButtonActive = true;
                    return;
                }

                this.searchButtonActive = false;
                return;
            },
            true
        );

        this.$scope.$watch(
            'paymentApprovalVm.isSupplierChecked',
            () => {
                if (this.isSupplierChecked) {
                    this.isInvoiceChecked = false;
                    this.isAmountChecked = false;
                    if (this.searchTerm && this.searchTerm.hasOwnProperty('length') && this.searchTerm.length >= 3) {
                        this.searchButtonActive = true;
                        return;
                    }
                }

                if (
                    !this.isInvoiceChecked &&
                    !this.isSupplierChecked &&
                    !this.isAmountChecked &&
                    (!this.searchTerm || this.searchTerm === '')
                ) {
                    this.searchButtonActive = true;
                    return;
                }

                this.searchButtonActive = false;
                return;
            },
            true
        );

        this.$scope.$watch(
            'paymentApprovalVm.isAmountChecked',
            () => {
                if (this.isAmountChecked) {
                    this.isSupplierChecked = false;
                    this.isInvoiceChecked = false;
                    if (this.searchTerm && this.searchTerm.hasOwnProperty('length') && this.searchTerm.length >= 1) {
                        var isDecimal = this._isDecimal(this.searchTerm);
                        if (isDecimal) {
                            this.searchButtonActive = true;
                            return;
                        }
                    }
                }

                if (
                    !this.isInvoiceChecked &&
                    !this.isSupplierChecked &&
                    !this.isAmountChecked &&
                    (!this.searchTerm || this.searchTerm === '')
                ) {
                    this.searchButtonActive = true;
                    return;
                }

                this.searchButtonActive = false;
                return;
            },
            true
        );

        angular.element('#paymentViewModal').on('hidden.bs.modal', () => {
            this.webPaymentApprovalIndividual = null;
        });

        angular.element('li.historicApprovals.active').on('click', (evt) => {
            const $historyTab = angular.element('li.historicApprovals.active');
            const shouldShouldBulkApprove = $historyTab.attr('aria-expanded');
        });
    }

    activate() {
        const userSession = this.LocalStorageService.retrieve('userSession');

        if (!userSession) {
            return;
        }

        this.paymentsDataService = this.paymentApprovalsDataService;
        this.buildingsDataService = this.BuildingsService;
        this.selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();
        if (this.selectedBuildingRef) {
            this.onSelectedBuildingChanged({}, this.selectedBuildingRef);
        }
        this.capturePayment();
        this.getPaymentTypes();
        this.initializeDatePicker();
        this.addMainAttachmentWatch();
    }

    async onSelectedBuildingChanged(event, incomingSchemeRef) {

        if (incomingSchemeRef == this.currentSchemeRef) {
            return;
        }
        this.clearSearchPayments();

        if (incomingSchemeRef) {
            this.currentSchemeRef = incomingSchemeRef;
        } else {
            this.currentSchemeRef = this.BuildingsService.getSelectedBuildingRef();
            if (!!!this.currentSchemeRef) {
                const userProfile = this.LocalStorageService.retrieve('userProfile');
                const { BuildingProfiles } = userProfile;

                if (!!BuildingProfiles && BuildingProfiles.length > 0) {
                    const buildingProfile = BuildingProfiles[0];
                    const { SchemeReference } = buildingProfile;
                    incomingSchemeRef = SchemeReference;
                    this.currentSchemeRef = SchemeReference;
                }
            }
        }

        if (this.currentSchemeRef && this.currentSchemeRef.length > 2) {
            this._switchIsLoading(true);
            this.getPaymentTypes();
            this.isPaymentBandEnabledBySchemeRef();
            this.paymentApprovalsDataService.getPaymentApprovals(this.currentSchemeRef, true)
                .then((data) => {
                    this.hasPaymentsInitiallySucceeded = true;
                    if (this.paymentsDataService.approvalsData && (this.paymentsDataService.approvalsData.approvals && this.paymentsDataService.approvalsData.approvals.length > 0)) {
                        this._mapIcons();
                    }
                })
                .catch((err) => {
                    console.error(err);
                })
                .finally(() => {
                    this._switchIsLoading(false);
                });
        }
    }

    showHistoryTab() {
        this.searchPayments();
        this.showBulkApprove = false;
    }

    togglePayment(paymentId) {
        this.paymentsDataService.approvalsData.approvals.forEach((payment) => {
            if (payment.PaymentId === paymentId) {
                payment.expanded = !payment.expanded;
            }
        });
    }

    _mapIcons() {
        this.paymentsDataService.approvalsData.approvals.forEach((payment) => {
            payment.expanded = true;
        });
    }

    setPanelCollapsed(status, id) {
        const $collapsing = angular.element('#' + id).hasClass('collapsing');
        if (!$collapsing) {
            status = !status;
        }
        return status;
    }

    bulkApprovePayments() {
        this.currentSchemeRef = this.currentSchemeRef ? this.currentSchemeRef : this.BuildingsService.getSelectedBuildingRef();
        const ids = this.paymentsForBulkApproval.map((payment) => payment.PaymentId);

        this.isBulkApproving = true;
        this._bulkStatusChange(ids, true);
        this.paymentApprovalsDataService
            .bulkApprovePayments(this.currentSchemeRef, ids)
            .then(
                (results) => {
                    if (results.WasSuccessful) {
                        this.NotificationService.success('APPROVED');
                    } else {
                        this.NotificationService.error('FAILED');
                    }
                },
                (err) => {
                    this.NotificationService.error('FAILED', err);
                }
            )
            .finally(() => {
                this.isBulkApproving = false;
                this._bulkStatusChange(ids, false);
            });
    }

    actionPayment(paymentId) {
        const payment = this.paymentsDataService.approvalsData.approvals.find((pa) => {
            return pa.PaymentId == paymentId;
        });

        if (payment.HasApproved) this._unApprovePayment(paymentId);
        else this._approvePayment(paymentId);
    }

    _approvePayment(paymentId) {
        this.currentSchemeRef = this.currentSchemeRef ? this.currentSchemeRef : this.BuildingsService.getSelectedBuildingRef();
        this._changePaymentApprovalStatus(paymentId, 'approving', true);
        this.paymentApprovalsDataService
            .approvePayment(paymentId, this.currentSchemeRef)
            .then(
                (results) => {
                    if (results.WasSuccessful) {
                        this.NotificationService.success('APPROVED');
                    } else {
                        this.NotificationService.success('FAILED');
                    }
                },
                (err) => {
                    this.NotificationService.error('FAILED', err);
                }
            )
            .finally(() => {
                this._changePaymentApprovalStatus(paymentId, 'approving', false);
                angular.element('#paymentViewModal').modal('hide');
            });
    }

    _unApprovePayment(paymentId) {
        this.currentSchemeRef = this.currentSchemeRef ? this.currentSchemeRef : this.BuildingsService.getSelectedBuildingRef();
        this._changePaymentApprovalStatus(paymentId, 'un-approving', true);
        this.paymentApprovalsDataService
            .unApprovePayment(paymentId, this.currentSchemeRef)
            .then(
                (results) => {
                    if (results.WasSuccessful) {
                        this.NotificationService.success('UN-APPROVED');
                    } else {
                        this.NotificationService.success('FAILED');
                    }
                },
                (err) => {
                    this.NotificationService.error('FAILED', err);
                }
            )
            .finally(() => {
                this._changePaymentApprovalStatus(paymentId, 'un-approving', false);
                angular.element('#paymentViewModal').modal('hide');
            });
    }

    async searchPayments() {
        const userName = this.LocalStorageService.retrieve('userProfile').UserName;

        let searchOption = 0;
        if (this.isInvoiceChecked) {
            searchOption = 1;
        }
        if (this.isSupplierChecked) {
            searchOption = 2;
        }
        if (this.isAmountChecked) {
            searchOption = 3;
        }

        try {
            const webPaymentSearch = {
                SchemeReference: this.currentSchemeRef,
                UserName: userName,
                SearchTerm: this.searchTerm || '',
                Options: searchOption,
                PageNumber: this.approvedPaymentsPaging.pageNumber,
                Limit: this.selectedPagingLimit
            };

            this.approvedPaymentsPaging.limit = this.selectedPagingLimit;

            this._switchIsSearching(true);
            await this.paymentApprovalsDataService.searchPayments(webPaymentSearch);
            this.approvedPaymentsPaging.numberOfResults = this.paymentsDataService.numberOfResults;

            if (this.approvedPaymentsPaging.pageNumber === 1) {
                this.approvedPaymentsPaging.firstItemIndex = 1;
            } else {
                this.approvedPaymentsPaging.firstItemIndex =
                    (this.approvedPaymentsPaging.pageNumber - 1) * this.approvedPaymentsPaging.limit + 1;
            }

            this.approvedPaymentsPaging.lastItemIndex =
                this.approvedPaymentsPaging.firstItemIndex + this.approvedPaymentsPaging.limit - 1;

            if (this.approvedPaymentsPaging.numberOfResults > 0) {
                this.approvedPaymentsPaging.maxPage = Math.ceil(
                    this.approvedPaymentsPaging.numberOfResults / this.approvedPaymentsPaging.limit
                );
                if (this.approvedPaymentsPaging.maxPage > 1) {
                    this.isPagingNavigationVisible = true;
                } else {
                    this.isPagingNavigationVisible = false;
                }
            } else {
                this.approvedPaymentsPaging.maxPage = 1;
                this.isPagingNavigationVisible = false;
                this.approvedPaymentsPaging.pageNumber = 1;
            }
        } catch (err) {
            console.error('Error while getting payment approval data: ', err);
        } finally {
            this._switchIsSearching(false);
        }
    }

    _switchIsSearching(flag) {
        this.$timeout(() => (this.isBusySearching = flag));
    }

    get approvePayments() {
        const canApprove = this.AuthorizationService.isAuthorized('Approve Payments');
        return canApprove;
    }

    capturePayment() {
        this.canPaymentcapture = this.AuthorizationService.isAuthorized('Capture Payment');
        return this.canPaymentcapture;
    }

    clearSearchPayments() {
        this.isInvoiceChecked = false;
        this.isSupplierChecked = false;
        this.isAmountChecked = false;
        this.selectedPagingLimit = 5;
        this.searchButtonActive = false;
        this.searchTerm = undefined;
        this.approvedPaymentsPaging.pageNumber = 1;
    }

    _changePaymentApprovalStatus(id, type, busy) {
        this.paymentsDataService.approvalsData.approvals.forEach((payment) => {
            if (payment.PaymentId === id) {
                if (type === 'approving') {
                    payment.isApproving = busy;
                } else if (type === 'un-approving') {
                    payment.isUnApproving = busy;
                } else if (type === 'querying') {
                    payment.isQuerying = busy;
                }
            }
        });
    }

    _isInt(value) {
        const reg = new RegExp('^[-]?[0-9]?[.]?[0-9]+$');
        let isNumber = false;

        if (reg.test(value)) {
            isNumber = true;
        }

        return isNumber;
    }

    _isDecimal(value) {
        value += '';
        return value.trim().length > 0 ? !isNaN(value) : false;
    }

    queryPayment(paymentId) {
        this.currentSchemeRef = this.currentSchemeRef ? this.currentSchemeRef : this.BuildingsService.getSelectedBuildingRef();
        this._changePaymentApprovalStatus(paymentId, 'querying', true);
        this.paymentApprovalsDataService
            .queryPayment(paymentId, this.query, this.currentSchemeRef)
            .then(
                (results) => {
                    if (results.WasSuccessful) {
                        this.NotificationService.success('QUERIED');
                    } else {
                        this.NotificationService.error('FAILED');
                    }
                    this.query = '';
                },
                (err) => {
                    this.NotificationService.error('FAILED', err);
                }
            )
            .finally(() => {
                this._changePaymentApprovalStatus(paymentId, 'querying', false);
                angular.element('#paymentViewModal').modal('hide');
            });
    }

    populateNewPaymentViewModal(paymentId) {
        this.awaitQueries = true;
        for (let i = 0; i < this.paymentsDataService.approvalsData.approvals.length; i++) {
            const payment = this.paymentsDataService.approvalsData.approvals[i];
            if (payment.PaymentId == paymentId) {
                this.webPaymentApprovalIndividual = payment;
                for (let j = 0; j < this.webPaymentApprovalIndividual.Attachments.length; j++) {
                    if (this.webPaymentApprovalIndividual.Attachments[j].IsInvoice) {
                        this.selectedDocumentIndex = j;
                        this.iframePaymentDocuments = this.$sce.trustAsResourceUrl(
                            this.webPaymentApprovalIndividual.Attachments[j].Path
                        );
                        //this._refreshEQCSS();
                        break;
                    }
                }

                return;
            }
        }
    }

    populateHistoryPaymentViewModal(paymentId) {
        for (let i = 0; i < this.paymentsDataService.approvalsData.approved.length; i++) {
            const payment = this.paymentsDataService.approvalsData.approved[i];
            if (payment.PaymentId == paymentId) {
                this.webPaymentApprovalIndividual = payment;
                for (let j = 0; j < this.webPaymentApprovalIndividual.Attachments.length; j++) {
                    if (this.webPaymentApprovalIndividual.Attachments[j].IsInvoice) {
                        const path = this.webPaymentApprovalIndividual.Attachments[j].Path.toLowerCase();
                        if (
                            path.includes(
                                this.webPaymentApprovalIndividual.Attachments[j].DocumentExtension.toLowerCase()
                            )
                        )
                            this.iframePaymentDocuments = this.$sce.trustAsResourceUrl(path);
                        else {
                            this.iframePaymentDocuments = this.$sce.trustAsResourceUrl(
                                path + this.webPaymentApprovalIndividual.Attachments[j].DocumentExtension
                            );
                        }

                        this.selectedDocumentIndex = j;
                        break;
                    }
                }

                return;
            }
        }
    }
    getInvoicePath(index = -1) {
        if (index === -1) {
            return;
        }

        const path = this.webPaymentApprovalIndividual.Attachments[index].Path.toLowerCase();
        if (path.includes(this.webPaymentApprovalIndividual.Attachments[index].DocumentExtension.toLowerCase()))
            this.iframePaymentDocuments = this.$sce.trustAsResourceUrl(path);
        else {
            this.iframePaymentDocuments = this.$sce.trustAsResourceUrl(
                path + this.webPaymentApprovalIndividual.Attachments[index].DocumentExtension
            );
        }
        this.selectedDocumentIndex = index;
        //mapping mobileview download button name.
        this.selectedDocumentTypeDesc = this.webPaymentApprovalIndividual.Attachments[index].Name;
    }

    checkPayment(paymentId) {
        for (let i = 0; i < this.paymentsDataService.approvalsData.approvals.length; i++) {
            const payment = this.paymentsDataService.approvalsData.approvals[i];
            if (payment.PaymentId == paymentId) {
                if (
                    this.paymentsDataService.approvalsData.approvals[i].hasOwnProperty('Checked') &&
                    this.paymentsDataService.approvalsData.approvals[i].Checked
                ) {
                    this.paymentsDataService.approvalsData.approvals[i].Checked = false;

                    const newCopy = this.paymentsForBulkApproval.filter((pmt) => {
                        var shouldRemove = pmt.PaymentId !== paymentId;
                        return shouldRemove;
                    });
                    this.paymentsForBulkApproval = newCopy;
                } else {
                    this.paymentsDataService.approvalsData.approvals[i].Checked = true;
                    this.paymentsForBulkApproval.push(this.paymentsDataService.approvalsData.approvals[i]);
                }
                return;
            }
        }
    }

    isQuerying() {
        let querying = false;
        const queryingPayments = this.paymentsDataService.approvalsData.approvals.filter((payment) => {
            const shouldInclude = payment.isQuerying;
            return shouldInclude;
        });
        querying = queryingPayments && queryingPayments.length > 0;
        return querying;
    }

    selectDocumentPreview(index) {
        this.selectedDocumentIndex = index;
    }

    _bulkStatusChange(ids, busy) {
        this.paymentsDataService.approvalsData.approvals.map((payment) => {
            const id = ids.find((_id) => {
                return _id === payment.PaymentId;
            });
            if (id) {
                payment.isApproving = busy;
            }
        });
    }

    _switchIsLoading(flag) {
        this.$timeout(() => (this.isBusy = flag));
    }
    _switchIsSaving(flag) {
        this.$timeout(() => (this.isBusySaving = flag));
    }

    async updateHasDuplicateInvoice() {
        if (!this.addEditPayment.InvoiceNumber || !this.addEditPayment.ServiceProviderId) {

            return;
        }

        try {

            this.$timeout(() => {
                this.addEditPaymenOptions.isCheckingForDuplicateInvoice = true;
                this.addEditPaymenOptions.showDuplicateInvoiceWarning = false;
            });

            const hasDuplicateInvoice =
                await this.paymentApprovalsDataService.checkInvoiceNumberHasDuplicate(
                    this.addEditPayment.ServiceProviderId,
                    this.addEditPayment.InvoiceNumber);

            this.$timeout(() => {
                this.addEditPaymenOptions.showDuplicateInvoiceWarning = hasDuplicateInvoice;
            });

        } catch (e) {
            this.$timeout(() => {
                this.addEditPaymenOptions.showDuplicateInvoiceError = false;
            });
            Console.error(e);
        }
        finally {
            this.$timeout(() => {
                this.addEditPaymenOptions.isCheckingForDuplicateInvoice = false;
            });
        }

    }

    async getPaymentTypes() {
        if (!this.canPaymentcapture) {
            return;
        }
        this._switchIsLoading(true);
        await this.paymentApprovalsDataService.getPaymentTypes()
            .then((data) => {
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                this._switchIsLoading(false);
            });

    }

    async searchServiceProvider() {
        this.addEditPayment.ServiceProviderId = undefined;
        this.paymentApprovalsDataService.serviceProviders = undefined;
        this.addEditPaymenOptions.serviceProviderChecked = false;
        this._switchIsSearching(true);
        await this.paymentApprovalsDataService.searchServiceProvider(this.addEditPaymenOptions.searchServiceTerm)
            .then((data) => {

            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                this._switchIsSearching(false);
            });
    }

    selectServiceProvider() {

        if (this.paymentApprovalsDataService.serviceProviders) {
            for (let i = 0; i < this.paymentApprovalsDataService.serviceProviders.length; i++) {
                const payment = this.paymentApprovalsDataService.serviceProviders[i];
                if (payment.ServiceProviderId = this.addEditPayment.ServiceProviderId) {
                    this.selectedserviceProviderName = payment.ServiceProviderName;
                    this.selectedServiceProviderSector = payment.ServiceProviderSector;
                }
            }
        }
        if (this.selectedserviceProviderName) {
            $("#ServiceProviderModal").modal("hide");
        }
    }
    closeServiceProviderModel() {
        this.addEditPaymenOptions.searchServiceTerm = undefined;
        this.addEditPayment.ServiceProviderId = undefined;
        this.paymentApprovalsDataService.serviceProviders = undefined;
    }
    closeSavePaymentModel() {
        this.addEditPaymenOptions.schemeConfirmed = false;
        this.addEditPaymenOptions.serviceProviderConfirmed = false;
        this.addEditPaymenOptions.invoiceNumberConfirmed = false;
        this.addEditPaymenOptions.amountConfirmed = false;
        this.addEditPaymenOptions.invoiceCaptureConfirmed = false;
        this.$timeout(() => {
            this.addMainAttachmentWatch();
        })
    }
    paymentByType() {
        if (this.addEditPayment.PaymentType && this.addEditPayment.PaymentType !== '') {
            this.getCurrentVatRateForScheme();
            return;
        }
        this.selectedserviceProviderName = undefined;
        this.addEditPayment.ServiceProviderId = undefined;
        this.addEditPaymenOptions.searchServiceTerm = undefined;
        this.paymentApprovalsDataService.serviceProviders = undefined;
        this.addEditPayment.InvoiceNumber = undefined;
        this.addEditPayment.TotalInvoiceAmount = undefined;
        this.addEditPaymenOptions.futureDatechecked = false;
        this.addEditPayment.FuturePaymentDate = undefined;
    }

    initializeDatePicker() {
        this.$timeout(() => {
            const selector = '#capturePaymentDate';
            const $input = $('#capturePaymentDate');
            let dateNow = new Date();
            let minimumDate = moment(dateNow).add(3, 'd').toDate();
            const startDate = moment(minimumDate).toDate();
            const options = {
                startDate,
                autoclose: true,
                forceParse: true,
                format: 'yyyy/mm/dd',
                assumeNearbyYear: true,
                enableOnReadonly: true,
                container: selector
            };
            $input.datepicker(options);
        }, 10000);
    }

    async getGLAccounts(searchAccoutTerm) {
        if (searchAccoutTerm.length < 2) {
            return;
        }
        let glAccountResults = await this.paymentApprovalsDataService.SearchGLAccounts(searchAccoutTerm, this.currentSchemeRef);
        glAccountResults = [...glAccountResults].splice(0, 8);
        return glAccountResults;
    }

    addNewAllocationRow() {
        const addAllocationAmount = this.FixNumber(this.Allocations.Amount);
        const addAllocationAccount = this.Allocations.GLAccount;
        const accountName = addAllocationAccount ? addAllocationAccount.AccountName : null;
        const accountCode = addAllocationAccount ? addAllocationAccount.AccountCode : null;

        if (isNaN(addAllocationAmount) || addAllocationAmount == 0 || typeof addAllocationAccount === undefined || accountName == null || accountCode == null) {
            return;
        }

        if (this.allocationAccountAlreadyAddedToPayment()) {
            this.Allocations.Amount = undefined;
            this.Allocations.GLAccount = undefined;
            alert('You have already added an allocation for this account.');
            return;
        }
        const newRow = {
            amount: this.FixNumber(addAllocationAmount),
            accountCode: accountCode,
            accountName: accountName
        };

        this.allocationRows.push(newRow);
        this.Allocations.Amount = undefined;
        this.Allocations.GLAccount = undefined;
    }

    removeAllocationRow(allocationRow) {
        const rowIndex = this.allocationRows.indexOf(allocationRow);

        if (rowIndex > -1) {
            this.allocationRows.splice(rowIndex, 1)
        }
    }

    FixNumber(brokenNumber) {
        const fixedNumber = Number(Number(brokenNumber).toFixed(2));
        return fixedNumber;
    }

    totalAllocationAmount() {
        let renurnVal = this.FixNumber(0.00);

        if ([...this.allocationRows].length > 0) {
            [...this.allocationRows].forEach(element => {
                renurnVal = renurnVal + this.FixNumber(element.amount);

            });
        }
        return renurnVal;
    }

    AllocationAmountMatchedInvoiceTotal() {
        let TotalInvoiceAmount = this.FixNumber(this.addEditPayment.TotalInvoiceAmount);
        if (this.totalAllocationAmount() == TotalInvoiceAmount) {
            this.allocationAmountMatchedInvoiceTotal = true;
            return true;
        }
        else {
            this.allocationAmountMatchedInvoiceTotal = false;
            return false;
        }
    }

    allocationAccountAlreadyAddedToPayment() {
        let acccode = this.Allocations.GLAccount.AccountCode;
        const existingAllocation = [...this.allocationRows].find(element => (element.accountCode == acccode));

        return !!existingAllocation
    }

    hasPaymentTypeBeenSelected() {
        return this.addEditPayment.PaymentType ? true : false;
    }

    canAddEditPaymentBeSubmitted() {
        const hasSelectedServiceProvider = this.addEditPayment.ServiceProviderId ? true : false;
        const hasInvoiceNumber = this.addEditPayment.InvoiceNumber ? true : false;
        const hasValidTotalAmount = this.addEditPayment.TotalInvoiceAmount ? true : false;
        const totalallocationsMatchTotalAmount = this.allocationAmountMatchedInvoiceTotal;
        this.addEditPaymenOptions.futureDatechecked ? this.addEditPayment.FuturePaymentDate : this.addEditPayment.FuturePaymentDate = undefined;
        const futureDatedPaymentIsValid = this.addEditPaymenOptions.futureDatechecked ? ((this.addEditPayment.FuturePaymentDate !== undefined) ? true : false) : true;
        const hasNoDuplicateInvoiceNumber =
            !this.addEditPaymenOptions.showDuplicateInvoiceWarning && !this.addEditPaymenOptions.showDuplicateInvoiceError;

        const hasInvoiceBeenUploaded = !!this.addEditPayment.Invoice;
        this.captureFormErrors();

        const canAddEditPaymentBeSubmitted = this.hasPaymentTypeBeenSelected() && hasSelectedServiceProvider && hasInvoiceNumber &&
            hasValidTotalAmount && totalallocationsMatchTotalAmount && futureDatedPaymentIsValid && hasInvoiceBeenUploaded && hasNoDuplicateInvoiceNumber;

        if (canAddEditPaymentBeSubmitted) {
            let paymentPayload = {
                "Allocations": [],
                "Attachments": [],
                "AmountString": this.addEditPayment.TotalInvoiceAmount.toString(),
                "Amount": this.addEditPayment.TotalInvoiceAmount,
                "InvoiceNumber": this.addEditPayment.InvoiceNumber,
                "SchemeReference": this.currentSchemeRef,
                "ServiceProviderId": this.addEditPayment.ServiceProviderId,
                "IsTaxable": this.addEditPayment.IsTaxable,
                "FuturePaymentDate": this.addEditPayment.FuturePaymentDate,
                "IsFutureDatedPayment": this.addEditPaymenOptions.futureDatechecked,
                "HasDuplicateWarningBeenShown": this.addEditPayment.showDuplicateInvoiceWarning,
                "VatRatePercentage": this.addEditPayment.VatRatePercentage,
                "PaymentTypeId": this.addEditPayment.PaymentType
            }

            this.allocationRows.forEach(element => {
                const allocationPayload = {
                    "AccountNumber": element.accountCode,
                    "AmountString": element.amount.toString(),
                    "Amount": element.amount,
                    "AmountWithTax": null
                }

                paymentPayload.Allocations.push(allocationPayload);
            });

            const attachmentBlobPayload = [];

            //Split out the invoice data from the blob
            paymentPayload.Attachments.push(
                {
                    "FileType": ".pdf",
                    "OriginalFileName": this.addEditPayment.Invoice.FileName,
                    "Blob": undefined,
                    "IsInvoice": true
                }
            );

            attachmentBlobPayload.push(this.addEditPayment.Invoice.Blob);

            //split out the supporting docs data from the blob
            if (this.addEditPayment.SupportingDocuments) {
                [...this.addEditPayment.SupportingDocuments].forEach(element => {
                    paymentPayload.Attachments.push(
                        {
                            "FileType": ".pdf",
                            "OriginalFileName": element.FileName,
                            "Blob": undefined,
                            "IsInvoice": false
                        }
                    );

                    attachmentBlobPayload.push(element.Blob);
                });
            }

            this.paymentPayload = paymentPayload;
            this.attachmentBlobPayload = attachmentBlobPayload;
        }
        return canAddEditPaymentBeSubmitted;

    }

    async addSubmitNewPayment() {
        if (this.canAddEditPaymentBeSubmitted() || true && !this.captureFormErrors()) {
            this._switchIsSaving(true);
            try {
                $("#SavePaymentCaptureModal").modal("hide");
                const submitPaymentResult = await this.paymentApprovalsDataService.submitPaymentForApporval(this.paymentPayload, this.attachmentBlobPayload);
                if (submitPaymentResult.statusText == "OK") {
                    this.NotificationService.success('PAYMENT SAVED SUCCESSFULLY');
                } else {
                    this.NotificationService.error('PAYMENT SAVING FAILED');
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.resetPaymentData();
                this.$timeout(() => {
                    this.addMainAttachmentWatch();
                })
                this._switchIsSaving(false);
            }
        }
    }

    addMainAttachmentWatch() {
        this.$timeout(() => {
            $('input[type=file].mainAttachmentBrowseFile').each((i, el) =>
                $(el).on('change', (evt) => {
                    evt.preventDefault();
                    const $target = $(evt.target);
                    const container = $target.closest('div[files-drop]');
                    const attrs = container.attr('files-drop').toLowerCase();

                    let type = 0;

                    if (attrs.includes('invoice')) {
                        type = 1;
                    } else if (attrs.includes('supporting documents')) {
                        type = 2;
                    }

                    if (type == 0) {
                        console.error('Cant determine doc type.');
                    }

                    const file = evt.target.files[0];

                    this.readAndStore(file, type);
                })
            );
        }, 5000);
    }

    handleDrop(files, type) {
        console.log('handleDrop');

        if (type == 'Invoice') {
            type = 1;
        } else if (type == 'Supporting Documents') {
            type = 2;
        }
        this.uploadFile(files[0], type);
    }

    uploadFile(file, type) {
        if (file) {
            this.readAndStore(file, type);
        } else {
            console.error('No file And/Or purchaser', this.addEditPayment);
        }

    }

    readAndStore(file, type) {
        if (file.type !== 'application/pdf') {
            const errorMsg = 'Wrong file type, only PDFs are allowed.';
            this.NotificationService.error(errorMsg);

            console.error(
                `${errorMsg} "${file.name}" is not in the correct format for ${type} - only PDFs are allowed.`
            );
        }

        else if (file.size >= 2097152) {
            const errorMsg = 'file size exceeded limit not allowed to upload.';
            this.NotificationService.error(errorMsg);

            console.error(
                `${errorMsg} "${file.name}" is exceeded limit, current file size "${file.size}" bytes - only below 2MB file size allowed.`
            );

        } else {
            const reader = new FileReader();
            reader.onload = () => {
                this.$timeout(() => {
                    const description = file.name;

                    if (type == 1) {
                        const newInvoiceattachment = {
                            FileName: description,
                            DocumentType: type,
                            Blob: base64js.fromByteArray(new Uint8Array(reader.result))
                        };
                        this.addEditPayment.Invoice = newInvoiceattachment;
                    }
                    if (type == 2) {
                        const newSupportattachment = {
                            FileName: description,
                            DocumentType: type,
                            Blob: base64js.fromByteArray(new Uint8Array(reader.result))
                        };

                        this.addEditPayment.SupportingDocuments.push(newSupportattachment);
                    }
                });
            };

            reader.readAsArrayBuffer(file);
        }


    }

    deleteAttachmentNag(attachment) {
        this.selectedAttachment = attachment;
    }

    hideModal(modal = 'deleteAttachmentNag') {
        const $modal = $(`#${modal}`);
        $modal.on('hide.bs.modal', () => {
            $('div.modal-backdrop.fade.in').each((i, el) => {
                const $el = $(el);
                const id = $el.attr('id');

                if (!id) {
                    $el.remove();
                    $('body').attr('style', `overflow-y:visible !important`);
                }
            });
        });

        $modal.modal('hide');
    }

    deleteAttachment() {
        this.hideModal();
        if (this.selectedAttachment.DocumentType == 1) {
            this.addEditPayment.Invoice = undefined;
        }

        else if (this.selectedAttachment.DocumentType == 2) {
            const rowIndex = this.addEditPayment.SupportingDocuments.indexOf(this.selectedAttachment);

            if (rowIndex > -1) {
                this.addEditPayment.SupportingDocuments.splice(rowIndex, 1);
            }
        }
    }

    captureFormErrors() {
        let results = [];

        const PaymentType = this.addEditPayment.PaymentType,
            ServiceProviderId = this.addEditPayment.ServiceProviderId,
            InvoiceNumber = this.addEditPayment.InvoiceNumber,
            TotalInvoiceAmount = this.addEditPayment.TotalInvoiceAmount,
            FuturePaymentDateChecked = this.addEditPaymenOptions.futureDatechecked,
            FuturePaymentDate = FuturePaymentDateChecked ? this.addEditPayment.FuturePaymentDate : '',
            Allocations = this.allocationRows,
            Invoice = this.addEditPayment.Invoice;

        const fieldsForValidation = {
            PaymentType,
            ServiceProviderId,
            InvoiceNumber,
            TotalInvoiceAmount,
            FuturePaymentDateChecked,
            FuturePaymentDate,
            Allocations,
            Invoice,
        };

        const customErrorMessages = {
            numeric: ':attribute must be a number.',
            required: ':attribute is required.',
        };

        const displayLabels = {
            PaymentType: 'Payment Type',
            ServiceProviderId: 'Service ProviderId',
            InvoiceNumber: 'Invoice Number',
            TotalInvoiceAmount: 'Total Invoice Amount',
            FuturePaymentDate: 'Future PaymentDate',
            Allocations: 'Allocations',
            Invoice: 'Invoice',
        };

        const rules = {
            PaymentType: 'required',
            ServiceProviderId: 'required',
            InvoiceNumber: 'required',
            TotalInvoiceAmount: 'required',
            FuturePaymentDate: [{ required_if: ['FuturePaymentDateChecked', true] }],
            Allocations: 'required',
            Invoice: 'required',
        };



        const validator = new Validator(fieldsForValidation, rules, customErrorMessages);
        validator.setAttributeNames(displayLabels);

        validator.passes();
        if (validator.errorCount > 0) {
            Object.keys(validator.errors.errors).forEach((name) => {
                let error = validator.errors.first(name);

                switch (error) {
                    case "Allocations is required.":
                        error = "at least one or more Allocations required";
                        break;
                    case "The Future PaymentDate field is required when FuturePaymentDateChecked is true.":
                        error = "Future PaymentDate is required.";
                        break;
                    default:
                        break;
                }

                results = [...results, error];
            });
        }

        return results;
    }
    async canSubmitPaymentForApproval() {
        this._switchIsSaving(true);
        let userProfile = this.LocalStorageService.retrieve('userProfile');
        userProfile.BuildingProfiles.find((building) => {
            const buildingRef = building.SchemeReference;
            if (buildingRef === this.currentSchemeRef) {
                return this.selectedSchemeName = building.SchemeName;
            }
        });
        const request = {
            SchemeReference: this.paymentPayload.SchemeReference,
            AllocationCodes: [...this.paymentPayload.Allocations].map(x => x.AccountNumber),
            ServiceProviderId: this.paymentPayload.ServiceProviderId,
            Amount: this.paymentPayload.Amount,
            CapturingUsername: null,
            PaymentTypeId: this.paymentPayload.PaymentTypeId,
            PaymentStatus: null
        };
        this.cansubmitpayment = await this.paymentApprovalsDataService.canSubmitPaymentForApproval(request);
        $("#SavePaymentCaptureModal").modal("show");
        this._switchIsSaving(false);
        return this.cansubmitpayment;
    }

    checksSuccessonSubmit() {
        this.cansubmitpayment = this.cansubmitpayment;
        let checksubmit = this.addEditPaymenOptions.schemeConfirmed && this.addEditPaymenOptions.serviceProviderConfirmed
            && this.addEditPaymenOptions.invoiceNumberConfirmed && this.addEditPaymenOptions.amountConfirmed &&
            this.addEditPaymenOptions.invoiceCaptureConfirmed;
        if (checksubmit) {
            return true;
        }
        return false;
    }

    async getCurrentVatRateForScheme() {
        let currentVatRate = null;
        currentVatRate = await this.paymentApprovalsDataService.getCurrentVatRateForScheme(this.currentSchemeRef);
        if (currentVatRate && currentVatRate != null) {
            this.addEditPayment.IsTaxable = true;
            this.addEditPayment.VatRatePercentage = currentVatRate;
        }
        return currentVatRate;
    }

    async isPaymentBandEnabledBySchemeRef() {
        this._switchIsSaving(true);
        let isPaymentBandEnabled = null;
        isPaymentBandEnabled = await this.paymentApprovalsDataService.isPaymentBandEnabledBySchemeRef(this.currentSchemeRef);
        if (isPaymentBandEnabled && isPaymentBandEnabled != null) {
            this.isPaymentBandEnabled = true;
        }
        this._switchIsSaving(false);
        return isPaymentBandEnabled;
    }
}
